<template>
  <div v-if="chatInfo.is_doing === 1"
  class="lf live_video_box"
  :class="liveBtnList.fullscreenOnOff ? 'live_video_box_fullscreen' : ''"
  >
    <VTcPlayer
    v-loading="loading"
    element-loading-text="直播加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 1)"
    ref="tcPlayer"
    class="live_box"
    :options="options"
    @load="onLoad"
    @error="onError"
    />
    <div v-show="!liveBtnList.playOnOff" class="video_btn_player" @click = 'onPlay'>
      <i class="iconfont icon-play1"></i>
    </div>
    <div class="video_btn_menu"
    :class="liveBtnList.fullscreenOnOff ? 'fullscreen' : ''">
      <!-- 播放按钮 -->
      <div class="video_btn_item video_btn_item_horn_paly lf">
        <i v-show="liveBtnList.playOnOff" class="iconfont icon-suspended" @click = 'onPause'></i>
        <i v-show="!liveBtnList.playOnOff" class="iconfont icon-play1" @click = 'onPlay'></i>
      </div>
      <!-- 音量按钮 -->
      <div class="video_btn_item video_btn_item_horn lf">
        <div class="block">
          <span class="demonstration">
            <i v-show="liveBtnList.progress > 0" class="iconfont icon-sound-filling" @click="hornSilence"></i>
            <i v-show="liveBtnList.progress === 0" class="iconfont icon-sound-Mute" @click="hornSilence"></i>
          </span>
          <el-slider
          v-model="liveBtnList.progress"
          @input = "hornInput"
          @change = "hornChange"
          ></el-slider>
        </div>
      </div>
      <!-- 全屏按钮 -->
      <div class="video_btn_item rt">
        <i v-show="liveBtnList.fullscreenOnOff" class="iconfont icon-fullscreen-shrink" @click = 'myFullScreen(true)'></i>
        <i v-show="!liveBtnList.fullscreenOnOff" class="iconfont icon-fullscreen-expand" @click = 'myFullScreen(false)'></i>
      </div>
      <!-- 弹幕开关 -->
      <div class="video_btn_item rt">
        <el-switch
          v-model="liveBtnList.barrageOnOff"
          active-color="#d7b76d"
          inactive-color="#8b8b8b"
          active-text="弹幕">
        </el-switch>
      </div>
    </div>
    <baberrage-view :live-btn-list = "liveBtnList"></baberrage-view>
  </div>
  <div v-else class="lf live_video_box" :class="liveBtnList.fullscreenOnOff ? 'live_video_box_fullscreen' : ''">
    <img :src="chatInfo.room_img" alt="">
  </div>
</template>

<script>
import { VTcPlayer } from 'v-tcplayer'
import baberrage from './baberrage.vue'
export default {
  components: {
    baberrageView: baberrage,
    VTcPlayer
  },
  inject: ['reload'],
  name: 'live',
  props: {
    chatInfo: {
      type: Object,
      required: true
    },
    apiType: {}
  },
  data () {
    return {
      loading: true,
      options: {},
      liveBtnList: {
        playOnOff: false,
        progress: 100,
        // 音量记录
        hornRecord: 100,
        // 弹幕开关
        barrageOnOff: true,
        // 是否全凭
        fullscreenOnOff: false
      }
    }
  },
  created () {
    if (this.chatInfo.is_doing === 1) {
      this.getonmessage()
    }
  },
  computed: {
    player () {
      // tcPlayer实例
      return this.$refs.tcPlayer.vTcPlayer
    }
  },
  methods: {
    // 音量控制
    hornInput () {
      this.player.volume(this.liveBtnList.progress / 100)
    },
    // 记录上一次音量的大小
    hornChange () {
      console.log(this.player.volume())
      this.liveBtnList.hornRecord = this.liveBtnList.progress
    },
    // 静音按钮
    hornSilence () {
      if (this.liveBtnList.progress === 0) {
        this.liveBtnList.progress = this.liveBtnList.hornRecord
      } else {
        this.liveBtnList.progress = 0
      }
    },
    // 全屏按钮
    myFullScreen () {
      if (!this.liveBtnList.fullscreenOnOff) {
        // 不是全屏
        this.liveBtnList.fullscreenOnOff = true
      } else {
        // 全屏
        this.liveBtnList.fullscreenOnOff = false
      }
    },
    // 视频地址存放
    getonmessage () {
      const obj = {
        m3u8: this.chatInfo.play_url.m3u8,
        flv: this.chatInfo.play_url.flv,
        rtmp: this.chatInfo.play_url.rtmp,
        live: true,
        width: '100%',
        height: '100%',
        autoplay: true, // 自动播放（腾讯云播放地址测试可以自动播放）
        poster: {
          style: 'cover',
          src: this.chatInfo.room_img
        },
        wording: {
          2032: '请求视频失败，请检查网络',
          2048: '请求m3u8文件失败，可能是网络错误或者跨域问题'
        }
      }
      this.options = obj
    },
    onLoad () {
      console.log(this.player.playing())
      this.liveBtnList.playOnOff = this.player.playing()
      this.loading = false
    },
    onPlay () {
      this.loading = false
      this.player.play()
      this.liveBtnList.playOnOff = true
    },
    onPause () {
      this.player.pause()
      this.liveBtnList.playOnOff = false
    },
    onError (data) {
      this.loading = false
    }
  }
}
</script>

<style scope>
  .vtp-player{
    width: 100%;
    height: 100%;
  }
  .el-tooltip__popper{
    line-height: 2.2;
  }
  .el-tooltip__popper.is-dark{
    color: #000;
  }
  .el-tooltip__popper span {
    padding: 10px;
  }
</style>
